/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Move_To_PersonalInputs */



/**
* | output |
* | --- |
* | "Move to “About you”" |
*
* @param {Memory_Move_To_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_move_to_personal = /** @type {((inputs?: Memory_Move_To_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Move_To_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach „Über dich“ verschieben")
	return /** @type {LocalizedString} */ ("Move to “About you”")
});